import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';

// Configuração de ambiente para controle do login
const environment = {
    production: false,
    enableLogin: false // Mude para false para desabilitar o login
};

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private isLoggedInSubject = new BehaviorSubject<boolean>(false);
    public isLoggedIn$ = this.isLoggedInSubject.asObservable();

    constructor(private router: Router) {
        this.checkAuthStatus();
    }

    /**
     * Verifica se o login está habilitado no ambiente
     */
    get isLoginEnabled(): boolean {
        return environment.enableLogin;
    }

    /**
     * Verifica se o usuário está logado
     */
    get isAuthenticated(): boolean {
        return this.isLoggedInSubject.value;
    }

    /**
     * Verifica o status de autenticação no localStorage
     */
    private checkAuthStatus(): void {
        if (!this.isLoginEnabled) {
            this.isLoggedInSubject.next(true);
            return;
        }

        const isLoggedIn = localStorage.getItem('sismet_logged_in') === 'true';
        this.isLoggedInSubject.next(isLoggedIn);
    }

    /**
     * Realiza o login (aceita qualquer email/senha se o login estiver habilitado)
     */
    login(email: string, password: string): Observable<boolean> {
        return new Observable(observer => {
            // Simula validação - aceita qualquer email/senha
            if (email && password) {
                localStorage.setItem('sismet_logged_in', 'true');
                localStorage.setItem('sismet_user_email', email);
                this.isLoggedInSubject.next(true);

                // Redireciona para o dashboard
                this.router.navigate(['/dashboard']);

                observer.next(true);
                observer.complete();
            } else {
                observer.next(false);
                observer.complete();
            }
        });
    }

    /**
     * Realiza o logout
     */
    logout(): void {
        localStorage.removeItem('sismet_logged_in');
        localStorage.removeItem('sismet_user_email');
        this.isLoggedInSubject.next(false);

        if (this.isLoginEnabled) {
            this.router.navigate(['/login']);
        }
    }

    /**
     * Obtém o email do usuário logado
     */
    getUserEmail(): string | null {
        return localStorage.getItem('sismet_user_email');
    }

    /**
     * Verifica se deve exibir a tela de login
     */
    shouldShowLogin(): boolean {
        return this.isLoginEnabled && !this.isAuthenticated;
    }
}